import { Fragment, useEffect } from "react";
import { createStyles, Container, Button, Divider, Space, Text, Group } from "@mantine/core";
import { Link } from "react-router-dom";
import { signOutUser } from "../../utils/firebase/firebase.utils";
import { useJuneProvider } from '../../contexts/analytics.context';

const useStyles = createStyles((theme) => ({

    mobileDropdownContainer: {
        position: 'fixed',
        width: '100%',
        height: 'calc(100% - 60px)',
        background: 'white',
        padding: theme.spacing.xl,
        paddingTop: '0',
        paddingBottom: '0',
    },

    mobileRelativeDiv: {
        width: '100%',
        height: '100%',
        position: 'relative',
    },

    bottomButton: {
        display: 'block',
        width: '100%',
        margin: '0 auto'
    },

    link: {
        color: 'black',
        textDecoration: 'none'
    },

    bottomLink: {
        color: 'black',
        fontWeight: '500',
        textAlign: 'center',
    },

    signOutLink: {
        cursor: 'pointer'
    },

    bottomWrapper: {
        width: '100%',
        position: 'absolute',
        bottom: '0',
    }

}));

const MobileDropdown = ({ setExpandedMobileMenu, textLinks, currentUser, setLogOutMessage }) => {

    const { classes } = useStyles();

    const close = () => { 
        setExpandedMobileMenu(false) 
    };

    const analytics = useJuneProvider();

    const handleSignout = async () => {
        if (currentUser) {
            try {
                const { uid } = currentUser;
                await signOutUser();
                analytics.track({
                    userId: uid,
                    event: 'Signed out',
                });
                setLogOutMessage('You have been logged out of your account.');
            } catch (error) {
                alert('There was an error signing you out. Please try again.');
            }
        }
        close();
    }

    useEffect(() => {
        window.addEventListener("resize", close);
        return () => {
            window.removeEventListener("resize", close);
        };
    }, []);

    return (
        <Container className={classes.mobileDropdownContainer}>
            <div className={classes.mobileRelativeDiv}>
                {
                    currentUser &&  
                    textLinks.map(link => (
                        <Fragment key={link.text}>
                            <Container 
                                p='0'
                                component={link.type === 'internal' ? Link : 'a'}
                                to= {link.type === 'internal' ? link.to : undefined}
                                href={link.type === 'external' ? link.to : undefined}
                                target={link.type === 'external' ? '_blank' : undefined}
                                className={classes.link}
                                onClick={close}
                            >
                                <div>
                                    <Space h="md" />
                                    <Group spacing='xs'>
                                        {link.icon}
                                        <Text size='lg'>{link.text}</Text>
                                    </Group>
                                    <Space h="md" />
                                </div>
                            </Container>
                            <Divider />
                        </Fragment>
                    ))
                }
                <div className={classes.bottomWrapper}>
                    <Button
                        size='lg'
                        className={classes.bottomButton}
                        component={Link}
                        to={currentUser ? '/account' : '/sign-up'}
                        onClick={close}
                        radius='md'
                        >
                        {currentUser ? 'My account' : 'Book a demo'}
                    </Button>
                    <Link
                        to={'/sign-in'}
                        className={classes.bottomLink}
                        onClick={handleSignout}
                    >
                        <div>
                            <Space h="xs" />
                            <Text size='lg'>
                                {currentUser ? 'Log out' : 'Sign in'}</Text>
                            <Space h="xs" />
                        </div>
                    </Link>
                    <Space h="xs" />
                </div>
            </div>
        </Container>
    )
}

export default MobileDropdown